import React from 'react';
import { BackTop } from 'antd';
import {
  BrowserRouter as Router,
} from 'react-router-dom';

import Routing from './Pages/Routing/Routing';



const App = () => {
  return (
    <>
     <Router>
      <Routing/>
     </Router>
     <BackTop/>
    </>
  )
}

export default App